module.exports = __webpack_public_path__ + "videos/mts-products-chats-promo.3bd0094.mp4";